module.exports = __webpack_public_path__ + "static/media/line_02.cad6b69b.png";